var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7H9V0.5C9 0.364583 8.94792 0.25 8.84375 0.15625C8.75 0.0520833 8.63542 0 8.5 0H7.5C7.36458 0 7.24479 0.0520833 7.14062 0.15625C7.04688 0.25 7 0.364583 7 0.5V7H0.5C0.364583 7 0.244792 7.05208 0.140625 7.15625C0.046875 7.25 0 7.36458 0 7.5V8.5C0 8.63542 0.046875 8.75521 0.140625 8.85938C0.244792 8.95312 0.364583 9 0.5 9H7V15.5C7 15.6354 7.04688 15.75 7.14062 15.8438C7.24479 15.9479 7.36458 16 7.5 16H8.5C8.63542 16 8.75 15.9479 8.84375 15.8438C8.94792 15.75 9 15.6354 9 15.5V9H15.5C15.6354 9 15.75 8.95312 15.8438 8.85938C15.9479 8.75521 16 8.63542 16 8.5V7.5C16 7.36458 15.9479 7.25 15.8438 7.15625C15.75 7.05208 15.6354 7 15.5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.113fe91891dff00586a5a67d79f246f1.svg";
export { ForwardRef as ReactComponent };